/**
 * Allergen and suitability helpers.
 * Ported from frontend-sales/CataloguePage.tsx.
 * Badge colors match Trac-IT Sales frontend (ProductSearchPage).
 */

import type { ItemRow } from '../shared/types';

export type AllergenDef = { field: keyof ItemRow; label: string; short: string; color: string };
export type SuitabilityDef = { field: keyof ItemRow; label: string; color: string };

export const ALLERGEN_LABELS: AllergenDef[] = [
  { field: 'item_is_gluten', label: 'Gluten', short: 'Gluten', color: '#e65100' },
  { field: 'item_is_egg', label: 'Egg', short: 'Egg', color: '#f9a825' },
  { field: 'item_is_nuts', label: 'Nuts', short: 'Nuts', color: '#6d4c41' },
  { field: 'item_is_soya', label: 'Soya', short: 'Soya', color: '#558b2f' },
  { field: 'item_is_dairy', label: 'Dairy', short: 'Milk', color: '#1565c0' },
  { field: 'item_is_sesame', label: 'Sesame', short: 'Sesame', color: '#00838f' },
  { field: 'item_is_sulphites', label: 'Sulphites', short: 'Sulphites', color: '#6a1b9a' },
  { field: 'item_is_fish', label: 'Fish', short: 'Fish', color: '#0277bd' },
  { field: 'item_is_celery', label: 'Celery', short: 'Celery', color: '#7cb342' },
  { field: 'item_is_mustard', label: 'Mustard', short: 'Mustard', color: '#ff8f00' },
  { field: 'item_is_lupin', label: 'Lupin', short: 'Lupin', color: '#5e35b1' },
  { field: 'item_is_mollusc', label: 'Mollusc', short: 'Mollusc', color: '#00695c' },
];

export const SUITABILITY_LABELS: SuitabilityDef[] = [
  { field: 'item_is_halal', label: 'Halal', color: '#2e7d32' },
  { field: 'item_is_vegetarian', label: 'Vegetarian', color: '#33691e' },
  { field: 'item_is_vegan', label: 'Vegan', color: '#1b5e20' },
];

/** Resolve badge colour for allergen/suitability label (Sales-consistent). */
export function getBadgeColor(label: string): string {
  const a = ALLERGEN_LABELS.find(x => x.label === label);
  if (a) return a.color;
  const s = SUITABILITY_LABELS.find(x => x.label === label);
  return s?.color ?? '#757575';
}

export function getAllergens(item: ItemRow): string[] {
  return ALLERGEN_LABELS.filter(a => item[a.field]).map(a => a.label);
}

export function getSuitability(item: ItemRow): string[] {
  return SUITABILITY_LABELS.filter(s => item[s.field]).map(s => s.label);
}
